import React, { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import axios from 'axios';

const UpdateDataModal = (props) => {
    const [formData, setFormData] = useState({ ...props.initialData });

    useEffect(() => {
        setFormData({ ...props.initialData });
    }, [props.initialData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let config = {
                method: 'put',
                data:formData, 
                url: `/api/data-entry/${formData.id}/`,
                headers: { 'Authorization': `Bearer ${props.accessToken}` }
              };
            const response = await axios.request(config);
          
            props.fetchData();
            props.onClose();
            // Handle success here
        } catch (error) {
            console.error('Error:', error);
            // Handle error here
        }
    };

    return (
        <Modal
            open={props.isOpen}
            onClose={props.onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Box
                sx={{
                    width: 600, // Adjust the width as needed
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 2,
                    overflow: 'auto' // Enable scrolling when necessary
                }}
            >
                <form onSubmit={handleSubmit}>
                    <h5 className='p-3 text-center'>UPDATE DATA ENTRY</h5>
                    <Grid container spacing={2}>
                        {Object.entries(formData).map(([key, value]) => (
                            <Grid item xs={12} md={6} key={key}>
                                {key === "id"?<h6 className='text-center text-dark'>ENTRY ID: {value}</h6>:
                                <>
                                    {key === "dateFrom" || key === "dateTo" || key === "handoverDate" ? (
                                        <TextField
                                            fullWidth
                                            label={key.replace(/([A-Z])/g, ' $1').trim()} // Convert camelCase to Title Case
                                            type="date"
                                            name={key}
                                            value={value}
                                            onChange={handleInputChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            size="small"
                                            required
                                        />
                                    ) : (
                                        <TextField
                                            fullWidth
                                            label={key.replace(/([A-Z])/g, ' $1').trim()} // Convert camelCase to Title Case
                                            name={key}
                                            value={value}
                                            onChange={handleInputChange}
                                            size="small"
                                            required
                                        />
                                    )}
                                </>
                                }
                            </Grid>
                        ))}
                    </Grid>
                    <div className='text-center p-2 '>
                        <Button className='mx-2 my-2' type="submit" variant="contained" color="success">Update Entry</Button>
                        <Button onClick={props.onClose} className='mx-2  my-2' variant="contained" color="warning">Cancel</Button>
                    </div>
                </form>
            </Box>
        </Modal>
    );
};

export default UpdateDataModal;
